<div *ngIf="checkIfUrl(data); else text">
  <img class="thumbnail" [src]="data" (click)="openImage(data)"/>
</div>
<ng-template #text>
  <div>
    <p>{{data}}</p>
  </div>

</ng-template>

